import base64 from './base64.js'
/**获取url参数具体字段的值 */
function getQueryVariable(variable) {
    const after = window.location.hash.split('?', 2)[1];
    if (after) {
        const reg = new RegExp('(^|&)' + variable + '=([^&]*)(&|$)');
        const r = after.match(reg);
        if (r != null) {
            return decodeURIComponent(r[2]);
        } else {
            return false;
        };
    };
};
function getQueryString(name) {
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    let r = window.location.search.substring(1).match(reg);
    if (r != null) {
        return unescape(r[2]);
    }
    return null;
};
function GetRequest() {
    let url = location.search; //获取url中"?"符后的字串
    let theRequest = new Object();
    if (url.indexOf("?") != -1) {
        let str = url.substring(1);
        let strs = str.split("&");
        for (let i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
        }
    }
    return theRequest;
}


/**获取base64加密后的参数对象 */
function getQueryBase64Params() {
    const after = window.location.hash.split('?', 2)[1];
    let result = {};
    if (after) {
        //解密
        let deCodeParams = base64ToUtf8(after);
        // let deCodeParams = new base64().decode(after);
        let params = deCodeParams.split('&');
        params.map(s => {
            let p = s.split('=');
            result[p[0]] = p[1];
        });
    };
    return result;
};
function getQueryBase64ParamsToJson() {
    let urlObj = {};
    urlObj = decodeURIComponent(window.location.href);
    urlObj = parseUrlParams(urlObj);
    if(urlObj.value){
        let b64OutUrl = base64ToUtf8(urlObj.value);
        // let b64OutUrl = new base64().decode(urlObj.value);
        // let b64OutUrl = new base64().decode(`ewogICAgImxvZ2luaWQiOiAiMzk2ODA3MjY5ODQiLAogICAgImNoYW5uZWwiOiAiYXBwbGUiLAogICAgImxzbiI6ICIxMzU1ODQwMzciLAogICAgInBpZCI6ICIzOTY4MDAwMyIsCiAgICAiaXNzaG93UUEiOiAiMSIsCiAgICAidmVyc2lvbiI6ICIyLjcuMSIsCiAgICAiYXBwbmFtZSI6ICJQcSIsCiAgICAiYW5kcm9pZGlkIjogIkVFOTEwRjA0LUIwNTQtNDJERC1BQ0ExLTg0RDJDOTMyRDk1RSIsCiAgICAiYXBwaWQiOiAiMzg2MjAiLAogICAgImlkZmEiOiAiNTMyMDYzMkYtNjgwOS00Qzg3LUE1QjctNTY3MkIzM0VDRDIwIgp9`);
        /* 简单的错误处理 */
        try {/* 可能会导致错误的代码 */
            b64OutUrl = eval('('+b64OutUrl+')');
            console.warn('参数是json');
        } catch (error) { /* 在错误发生时怎么处理 */
            b64OutUrl = parseUrlParams(b64OutUrl);
            console.warn(`参数是key=value`);
        };
        
        urlObj = {
            ...urlObj,
            ...b64OutUrl,
        };
    };
    // let after = window.location.hash.split('?', 2)[1];
    // let result = {};
    // if (after) {
    //     after = after.replace(/%20/g, '+').replace(/%3D/g, '=').replace(/\s+/g, '+');
    //     if(after.indexOf('=' !== -1)){
    //         let base64Str = after.split('=')[1];
    //         let deCodeParams = new base64().decode(base64Str);
    //         result = JSON.parse(deCodeParams);
    //     };
    //     //解密
    // };
    return urlObj;
};
/**获取参数对象 */
function getQueryParams() {
    const after = window.location.hash.split('?', 2)[1];
    let result = {};
    if (after) {
        let params = after.split('&');
        params.map(s => {
            let p = s.split('=');
            result[p[0]] = p[1];
        });
    };
    return result;
};
export default {
    getQueryVariable: getQueryVariable,
    getQueryParams: getQueryParams,
    getQueryBase64Params: getQueryBase64Params,
    getQueryBase64ParamsToJson: getQueryBase64ParamsToJson,
    GetRequest:GetRequest,
};

/* url参数转json方法 */
function parseUrlParams(url) {
    let params = {};
    let nowUrl = url.split('?');
    let queryString = nowUrl[1]||nowUrl[0];
    if (queryString) {
        let pairs = queryString.split('&');
        pairs.forEach(pair => {
            pair = pair.replace(/=/,`--=--`);
            let keyValues = pair.split('--=--');
            let key = decodeURIComponent(keyValues[0]);
            let value = decodeURIComponent(keyValues[1]);
            params[key] = valueFind(value);
        });
    };
    let hashIndex = url.indexOf('#');
    if (hashIndex !== -1) {
        let hashValue = url.substring(hashIndex + 1);
        if (hashValue.includes('=')) {
            let hashParams = hashValue.split('&');
            hashParams.forEach(param => {
                let keyValues = param.split('=');
                let key = decodeURIComponent(keyValues[0]);
                let value = decodeURIComponent(keyValues[1]);
                params[key] = valueFind(value);
            });
        } else {
            params['hash'] = hashValue;
        };
    };
    return params;
    /* value过滤 */
    function valueFind(val){
        let outVal = val;
        if(typeof val == 'string'){
            outVal = outVal.split("?")[0];
            outVal = outVal.split("&")[0];
            outVal = outVal.split("#")[0];
            outVal = outVal.replace(/ /g, '+');
        };
        return outVal;
    };
};

// 编码非ASCII字符
function utf8ToBase64(str) {
    const bytes = new TextEncoder().encode(str);
    const binary = String.fromCharCode(...bytes);
    return btoa(binary);
}

// 解码非ASCII字符
function base64ToUtf8(base64Val) {
    const binary = new base64().decode(base64Val);
    // const binary = atob(base64Val);
    const bytes = Uint8Array.from(binary, char => char.charCodeAt(0));
    return new TextDecoder().decode(bytes);
}


// WEBPACK FOOTER //
// ./src/utils/util.js